'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
import UIModalPanel from 'UIComponents/dialog/UIModalPanel';
import UIDialogHeader from 'UIComponents/dialog/UIDialogHeader';
import UIDialogCloseButton from 'UIComponents/dialog/UIDialogCloseButton';
import H2 from 'UIComponents/elements/headings/H2';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIDialogBody from 'UIComponents/dialog/UIDialogBody';
import UIDialogFooter from 'UIComponents/dialog/UIDialogFooter';
import UIButton from 'UIComponents/button/UIButton';
import UIIconButton from 'UIComponents/button/UIIconButton';
import UIIcon from 'UIComponents/icon/UIIcon';
import { FLINT, CANDY_APPLE } from 'HubStyleTokens/colors';
import UITextInput from 'UIComponents/input/UITextInput';
import KeywordMatchTypeSelect from 'AdsUI/components/campaign-reporting/KeywordMatchTypeSelect';
import UIFlex from 'UIComponents/layout/UIFlex';
import UILoadingButton from 'UIComponents/button/UILoadingButton';
import Small from 'UIComponents/elements/Small';
const ErrorText = styled(Small).withConfig({
  displayName: "KeywordModal__ErrorText",
  componentId: "sc-1d3n40q-0"
})(["display:block;color:", ";padding-top:4px;"], CANDY_APPLE);

const HeaderRow = () => /*#__PURE__*/_jsxs(UIFlex, {
  align: "center",
  justify: "between",
  children: [/*#__PURE__*/_jsx("div", {
    style: {
      width: '60%'
    },
    className: "p-right-2",
    children: /*#__PURE__*/_jsx("strong", {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "campaigns.management.addEntity.keywordTable.keyword"
      })
    })
  }), /*#__PURE__*/_jsx("div", {
    style: {
      width: '40%'
    },
    children: /*#__PURE__*/_jsx("strong", {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "campaigns.management.addEntity.keywordTable.matchType"
      })
    })
  })]
});

const KeywordRow = ({
  keyword,
  showDelete,
  showErrors,
  onChangeText,
  onChangeType,
  onDelete
}) => /*#__PURE__*/_jsxs(UIFlex, {
  align: "start",
  justify: "between",
  className: "m-bottom-2",
  children: [/*#__PURE__*/_jsxs("div", {
    style: {
      width: '60%'
    },
    className: "p-right-2",
    children: [/*#__PURE__*/_jsx(UITextInput, {
      value: keyword.keywordText,
      onChange: onChangeText,
      error: !keyword.keywordText && showErrors
    }), showErrors && !keyword.keywordText && /*#__PURE__*/_jsx(ErrorText, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "campaigns.management.addEntity.keywordTable.textRequired"
      })
    })]
  }), /*#__PURE__*/_jsx("div", {
    style: {
      width: '30%'
    },
    children: /*#__PURE__*/_jsx(KeywordMatchTypeSelect, {
      value: keyword.matchType,
      onChange: onChangeType
    })
  }), /*#__PURE__*/_jsx("div", {
    style: {
      width: '10%',
      height: '100%'
    },
    className: "p-x-2 m-y-auto",
    children: showDelete && /*#__PURE__*/_jsx(UIIconButton, {
      use: "unstyled",
      onClick: onDelete,
      children: /*#__PURE__*/_jsx(UIIcon, {
        name: "delete",
        color: FLINT
      })
    })
  })]
});

const AddKeywordButton = ({
  onClick
}) => /*#__PURE__*/_jsxs(UIButton, {
  use: "link",
  onClick: onClick,
  children: [/*#__PURE__*/_jsx(UIIcon, {
    name: "add",
    className: "m-right-1"
  }), /*#__PURE__*/_jsx(FormattedMessage, {
    message: "campaigns.management.addEntity.addKeyword"
  })]
});

const KeywordModal = ({
  keywords,
  showErrors,
  creating,
  createFailed,
  onAddNewKeyword,
  onChangeText,
  onChangeType,
  onDelete,
  onCancel,
  onSubmit
}) => /*#__PURE__*/_jsxs(UIModalPanel, {
  children: [/*#__PURE__*/_jsxs(UIDialogHeader, {
    children: [/*#__PURE__*/_jsx(UIDialogCloseButton, {
      onClick: onCancel
    }), /*#__PURE__*/_jsx(H2, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "campaigns.management.addEntity.types.ADWORDS.keyword"
      })
    })]
  }), /*#__PURE__*/_jsxs(UIDialogBody, {
    children: [/*#__PURE__*/_jsx(HeaderRow, {}), keywords.map((keyword, index) => /*#__PURE__*/_jsx(KeywordRow, {
      keyword: keyword,
      showDelete: keywords.size > 1,
      showErrors: showErrors,
      onChangeText: e => onChangeText(index, e.target.value),
      onChangeType: newType => onChangeType(index, newType),
      onDelete: () => onDelete(index)
    }, index)), /*#__PURE__*/_jsx(AddKeywordButton, {
      onClick: onAddNewKeyword
    })]
  }), /*#__PURE__*/_jsxs(UIDialogFooter, {
    children: [/*#__PURE__*/_jsx(UILoadingButton, {
      loading: creating,
      failed: createFailed,
      use: "primary",
      onClick: onSubmit,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "add"
      })
    }), /*#__PURE__*/_jsx(UIButton, {
      use: "secondary",
      onClick: onCancel,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "cancelButton"
      })
    })]
  })]
});

export default KeywordModal;